import OneColumnLayout from '@/layouts/OneColumnLayout.vue';
import HeroLayout from '@/layouts/HeroLayout.vue';
import EducatorHubLayout from '@/layouts/EducatorHubLayout.vue';
import LandingLayout from '@/layouts/LandingLayout.vue';
import InsightsRoutes from './insights';

export default [
  {
    path: 'home',
    name: 'educator-hub-home',
    component: () => import('@/views/educatorHub/EducatorHubHome.vue' as any),
    meta: {
      layout: HeroLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Educator Home',
    },
  },
  {
    path: 'playbook/discussion-ideas',
    name: 'educator-hub-discussion-ideas',
    component: () => import('@/views/educatorHub/playbook/DiscussionIdeas.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Discussion Ideas',
    },
  },
  {
    path: 'playbook/facilitation-guide',
    name: 'educator-hub-facilitation-guide',
    component: () => import('@/views/educatorHub/playbook/FacilitationGuide.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Facilitation Guide',
    },
  },
  {
    path: 'playbook/student-safety',
    name: 'educator-hub-student-safety',
    component: () => import('@/views/educatorHub/playbook/StudentSafety.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Student Safety',
    },
  },
  {
    path: 'playbook/more-reading',
    name: 'educator-hub-more-reading',
    component: () => import('@/views/educatorHub/playbook/MoreReading.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'More Reading',
    },
  },
  {
    path: 'playbook/civic-gym-program-design',
    name: 'educator-hub-civic-gym-program-design',
    component: () => import('@/views/educatorHub/playbook/CivicGymDesign.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Civic Gym Program Design',
    },
  },
  {
    path: 'playbook/about-unify-america',
    name: 'educator-hub-about-unify-america',
    component: () => import('@/views/educatorHub/playbook/AboutUnifyAmerica.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'About Unify America',
    },
  },
  {
    path: 'playbook/using-the-civic-gym-hub',
    name: 'educator-hub-using-the-civic-gym-hub',
    component: () => import('@/views/educatorHub/playbook/UsingTheHub.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Using the Civic Gym Hub',
    },
  },
  {
    path: 'playbook/how-students-are-matched',
    name: 'educator-hub-how-students-are-matched',
    component: () => import('@/views/educatorHub/playbook/HowStudentsAreMatched.vue' as any),
    meta: {
      layout: OneColumnLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'How Students Are Matched',
    },
  },
  {
    path: 'attendance',
    name: 'attendance-view',
    meta: {
      layout: EducatorHubLayout,
      renderNav: true,
      educatorsOnly: true,
      title: 'Attendance',
    },
    component: () => import('@/views/educatorHub/dashboards/AttendanceReport.vue'),
  },
  {
    path: 'insights',
    name: 'insights-home',
    meta: {
      layout: LandingLayout,
      renderNav: true,
      title: 'Insights',
    },
    children: [...InsightsRoutes],
  },
];
